// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd2-cls1_AAd","cls2":"PodcastLibraryAd2-cls2_1Jo PodcastLibraryAd2-cls1_AAd"};